import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Aplicatii from "./pages/Aplicatii";
import Descarcari from "./pages/Descarcari";
import Configurator from "./pages/Configurator";
import AIBoard from "./pages/AIBoard";
import Istoric from "./pages/Istoric";
import Evolutii from "./pages/Evolutii";
import Comparatii from "./pages/Comparatii";
import RataSucces from "./pages/RataSucces";
import Productie from "./pages/Productie";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-100 text-slate-500">
        Se incarca...
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/aplicatii"
        element={
          <ProtectedRoute>
            <Aplicatii />
          </ProtectedRoute>
        }
      />
      <Route
        path="/descarcari"
        element={
          <ProtectedRoute>
            <Descarcari />
          </ProtectedRoute>
        }
      />
      <Route
        path="/erp-vechi"
        element={
          <ProtectedRoute>
            <Descarcari variant="vechi" key="erp-vechi" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/configurator"
        element={
          <ProtectedRoute>
            <Configurator />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ai-board"
        element={
          <ProtectedRoute>
            <AIBoard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/istoric"
        element={
          <ProtectedRoute>
            <Istoric />
          </ProtectedRoute>
        }
      />
      <Route path="/evolutii" element={<ProtectedRoute><Evolutii /></ProtectedRoute>} />
      <Route path="/comparatii" element={<ProtectedRoute><Comparatii /></ProtectedRoute>} />
      <Route path="/rata-succes" element={<ProtectedRoute><RataSucces /></ProtectedRoute>} />
      <Route path="/productie" element={<ProtectedRoute><Productie /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
